var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal-action-" + _vm.action,
      attrs: {
        id: "modal-action-" + _vm.action,
        title: _vm.title + " documento",
        "no-close-on-backdrop": "",
        "ok-title": _vm.title,
        "cancel-title": "Cancelar",
        "cancel-disabled": _vm.isProcessing,
        "ok-disabled":
          (!!_vm.stepOffice.type && !_vm.canResendToOffice) || _vm.isProcessing,
        size: "lg"
      },
      on: { ok: _vm.commitAction, cancel: _vm.cancelProcess }
    },
    [
      _vm.action === "resend"
        ? _c(
            "div",
            [
              _c("resend-approval", {
                attrs: {
                  "step-id": _vm.stepId,
                  "is-signer": _vm.isSigner,
                  "has-signature-positon": _vm.hasSignaturePosition,
                  officeType: _vm.stepOffice,
                  "is-office": _vm.isOffice,
                  "is-official": _vm.isOfficial,
                  officialOfficeId: _vm.officialOfficeId
                },
                on: { "can-resend-to-office": _vm.handleCanResendToOffice },
                model: {
                  value: _vm.resendSubject,
                  callback: function($$v) {
                    _vm.resendSubject = $$v
                  },
                  expression: "resendSubject"
                }
              }),
              _vm.error.message !== ""
                ? _c(
                    "div",
                    {
                      staticClass:
                        "con-text-validation span-text-validation-danger\n        vs-input--text-validation-span v-enter-to text-right",
                      staticStyle: { height: "32px" }
                    },
                    [
                      _c("span", { staticClass: "span-text-validation" }, [
                        _vm._v(" " + _vm._s(_vm.error.message) + " ")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "mt-2" }, [
        _c(
          "form",
          { attrs: { "data-vv-scope": "comment-management" } },
          [
            _c("vs-textarea", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: _vm.action === "reject", min: 5 },
                  expression: "{required: action === 'reject', min: 5}"
                }
              ],
              staticClass: "mb-2",
              attrs: {
                maxlength: "1000",
                counter: "1000",
                label: "Comentario",
                name: "comment"
              },
              model: {
                value: _vm.comment,
                callback: function($$v) {
                  _vm.comment = $$v
                },
                expression: "comment"
              }
            }),
            _vm.errors.first("comment-management.comment")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                    staticStyle: { height: "20px" }
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first("comment-management.comment")
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm.enableAttachButton
          ? _c(
              "div",
              { staticClass: "my-5 text-right" },
              [
                _c("UploadMultipleFiles", {
                  attrs: {
                    permission: "*",
                    text: "Agregar",
                    "upload-to": _vm.urlFile,
                    "type-button": "small",
                    "button-class": "",
                    "container-class": "text-right"
                  },
                  on: {
                    input: function($event) {
                      return _vm.addAdditionalFile()
                    }
                  },
                  model: {
                    value: _vm.file,
                    callback: function($$v) {
                      _vm.file = $$v
                    },
                    expression: "file"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.commentFiles, function(file) {
            return _c("div", { key: file.id, staticClass: "col-2" }, [
              _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _c("vs-icon", {
                    attrs: {
                      icon: "description",
                      size: "30px",
                      color: "primary"
                    }
                  }),
                  _c("b", { staticClass: "text-truncate w-100 text-center" }, [
                    _vm._v(" " + _vm._s(file.name) + " ")
                  ]),
                  _c("vs-button", {
                    attrs: { color: "danger", type: "flat", icon: "clear" },
                    on: {
                      click: function($event) {
                        return _vm.removeAdditionalFile(file.id)
                      }
                    }
                  })
                ],
                1
              )
            ])
          }),
          0
        )
      ]),
      _vm.isProcessing
        ? _c("div", { staticClass: "loading-overlay" }, [
            _c("div", { staticClass: "loading-content" }, [
              _c(
                "div",
                {
                  staticClass: "spinner-border spinner-border-lg text-primary",
                  attrs: { role: "status" }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Procesando...")
                  ])
                ]
              ),
              _c("div", { staticClass: "mt-3" }, [
                _c("div", { staticClass: "h5 mb-1" }, [
                  _vm._v("Procesando ejecución")
                ]),
                _c("div", { staticClass: "text-muted" }, [
                  _vm._v("Por favor espera, esto puede tomar unos segundos...")
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }